import { AppDispatch, Store } from 'store';

const navigateToEditorOperation = (source: string) => async (dispatch: AppDispatch, getState: () => Store) => {
  const store = getState();
  const {
    publicAssetAbstractProductData,
    selectedAbstractProduct,
    currentProduct,
    selectedBundleProducts,
    sourceImageId,
  } = store.publicAssetProduct;
  if (!publicAssetAbstractProductData) {
    return;
  }
  const prod = publicAssetAbstractProductData?.products.find(
    (product) => product.slug === selectedAbstractProduct?.slug,
  );
  const editorUrl = prod?.followUrl;
  const abstractProduct = selectedAbstractProduct?.slug || '';
  const internalUid = currentProduct?.internalUid;
  let queryParams = `abstractProduct=${abstractProduct}&internalUid=${internalUid}&source=${source}&sourceImageId=${sourceImageId}`;
  // add bundled product to editor
  let bundledProducts;
  if (
    selectedBundleProducts &&
    selectedBundleProducts.length > 0 &&
    selectedBundleProducts[0].bundleGroupId > 0 &&
    selectedBundleProducts[0].productId > 0
  ) {
    bundledProducts = [{ bgid: selectedBundleProducts[0].bundleGroupId, pid: selectedBundleProducts[0].productId }];
  }
  if (bundledProducts) {
    queryParams = `${queryParams}&bundledProducts=${JSON.stringify(bundledProducts)}`;
  }
  window.location.href = `${editorUrl?.split('?')[0]}?${queryParams}`;
};

export default navigateToEditorOperation;
